module.exports = __webpack_public_path__ + "img/C3.83dd355a.svg";